import { Component, Host, h, Prop, Event, EventEmitter, Element, Watch } from '@stencil/core';
import { PanelTileClickedEvent } from './sew-ws-services.types';

@Component({
    tag: 'sew-ws-services-item',
    styleUrl: 'sew-ws-services-item.scss',
    shadow: true,
})
export class SewWsServicesItem {
    @Element() host: HTMLSewWsServicesItemElement;

    @Prop() label: string;
    @Prop() shortendLabel: string;
    @Prop() icon: string;
    @Prop({ reflect: true }) active: boolean;
    @Prop({ reflect: true }) openContent: boolean;

    @Event() itemClickedEmitter: EventEmitter<PanelTileClickedEvent>;

    private contentElement: HTMLDivElement;

    @Watch('active')
    watchActiveHandler(): void {
        this.host.style.setProperty('--content-height', this.contentElement.scrollHeight + 'px');
    }

    private toggleItem = (): void => {
        this.itemClickedEmitter.emit({ clickedItem: this.host, active: !this.active });
    };

    render() {
        return (
            <Host>
                <button onClick={this.toggleItem}>
                    <sew-icon class="svg service-icon" icon={this.icon} size="xl" />
                    <span>{this.shortendLabel}</span>
                    <sew-icon class="chevron-icon svg" icon="arrow-chevron-down" size="l" />
                </button>

                <div class="content" ref={el => (this.contentElement = el as HTMLDivElement)}>
                    <slot />
                </div>
            </Host>
        );
    }
}
